module.exports = __webpack_public_path__ + "static/media/angry-words.e47570f8.png";